<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add FAQ Section</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/faqsections" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createFaqsection" v-if="faqsection">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="faqsection.faqHeader"
                                          label="Section Header"
                                          placeholder="Enter Section Header"
                                          v-validate="rules.faqHeader"
                                          data-vv-name="Section Header"
                                          cus-name="Section Header"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create FAQ Section
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateFAQSection',
        created (){
    },
    data () {
        return {
            faqsection: {
              faqHeader: '',
                active: '1'
            },
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              faqHeader: {required : true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
        createFaqsection () {
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_FAQSECTION', this.faqsection)
                .then((res) => {
                  console.log("ADD_FAQSECTION res : ", res);
                  if(res) this.showPopup('Success!', 'FAQ Section is successfully created', 'success', ()=>this.$router.push('/admin/faqsections'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_TESTIMONIAL API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {

    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FAQSect/CreateFAQSection.vue